module.exports = __webpack_public_path__ + "static/img/bjrcb.eca6aaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank/bjrcb.png
// module id = Cq78
// module chunks = 93